// import React, { useState } from "react";
// import { Tree, Input } from "antd";
// const { Search } = Input;
// const SearchableTree = (props) => {
//   const data = props.treeData;
//   const [expandedKeys, setExpandedKeys] = useState([]);
//   const [searchValue, setSearchValue] = useState("");
//   const [autoExpandParent, setAutoExpandParent] = useState(true);

//   const onExpand = (expandedKeys) => {
//     setExpandedKeys(expandedKeys);
//     setAutoExpandParent(false);
//   };

//   const onChange = (e) => {
//     const { value } = e.target;
//     setSearchValue(value);
//     setAutoExpandParent(true);
//   };

//   const loop = (data) =>
//     data.map((item) => {
//       const index = item.account_name.toLowerCase().indexOf(searchValue.toLowerCase());
//       const title =
//         index > -1 ? (
//           <span key={item.id}>
//             <b> {item.account_no}</b> - {item.account_name.substr(0, index)}
//             <span style={{ color: "#f50" }}>
//               {item.account_name.substr(index, searchValue.length)}
//             </span>
//             {item.account_name.substr(index + searchValue.length)}
//           </span>
//         ) : (
//           <span>{item.title}</span>
//         );
//       if (item.children) {
//         return { ...item, title, children: loop(item.children) };
//       }

//       return { ...item, title };
//     });
//   const handleData = (e) => {
//     console.log(e);
//   };
//   return (
//     <>
//       <Search
//        style={{ marginBottom: 16,width:'300px' }}
//         placeholder="Search"
//         onChange={onChange}
//       />
//       <Tree

//         onExpand={onExpand}
//         expandedKeys={expandedKeys}
//         autoExpandParent={autoExpandParent}
//         treeData={loop(data)}
//         onClick={handleData}
//         defaultExpandAll
//         onSelect={(selectedKeys, info) => {
//           console.log('selected', selectedKeys, info);
//         }}
//       />
//     </>
//   );
// };

// export default SearchableTree;
import React, { useState, useEffect } from "react";
import { Tree, Input } from "antd";

const { Search } = Input;

const SearchableTree = (props) => {
  const data = props.treeData;
  const [expandedKeys, setExpandedKeys] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [autoExpandParent, setAutoExpandParent] = useState(true);

  useEffect(() => {
    // Start with collapsed tree - no keys expanded
    setExpandedKeys([]);
  }, [data]);

  const getAllKeys = (data) => {
    const keys = [];
    data.forEach((item) => {
      keys.push(item.account_no); // Use account_no as key
      if (item.children && item.children.length > 0) {
        keys.push(...getAllKeys(item.children));
      }
    });
    return keys;
  };

  const onExpand = (expandedKeys) => {
    setExpandedKeys(expandedKeys);
    setAutoExpandParent(false);
  };

  const onChange = (e) => {
    const { value } = e.target;
    setSearchValue(value);

    if (value) {
      // When searching, expand nodes that contain matches
      const matchingKeys = getMatchingKeys(data, value);
      setExpandedKeys(matchingKeys);
      setAutoExpandParent(true);
    } else {
      // When search is cleared, collapse all
      setExpandedKeys([]);
    }
  };

  const getMatchingKeys = (data, searchValue) => {
    const keys = [];
    const search = searchValue.toLowerCase();

    data.forEach((item) => {
      const nameMatch = item.account_name.toLowerCase().includes(search);
      const noMatch = item.account_no.toLowerCase().includes(search);

      if (nameMatch || noMatch) {
        keys.push(item.account_no);
      }

      if (item.children && item.children.length > 0) {
        const childKeys = getMatchingKeys(item.children, searchValue);
        if (childKeys.length > 0) {
          // Expand parent if any child matches
          keys.push(item.account_no);
          keys.push(...childKeys);
        }
      }
    });

    return keys;
  };

  // Transform backend data to Ant Design Tree format with search highlighting
  const transformData = (data) =>
    data.map((item) => {
      const searchIndex = item.account_name
        .toLowerCase()
        .indexOf(searchValue.toLowerCase());

      const accountNoIndex = item.account_no
        .toLowerCase()
        .indexOf(searchValue.toLowerCase());

      // Create title with highlighting
      const title =
        searchIndex > -1 || accountNoIndex > -1 ? (
          <span>
            <b style={{ color: accountNoIndex > -1 ? "#f50" : "#1890ff" }}>
              {item.account_no}
            </b>
            {" - "}
            {searchIndex > -1 ? (
              <>
                {item.account_name.substr(0, searchIndex)}
                <span style={{ color: "#f50", fontWeight: "bold" }}>
                  {item.account_name.substr(searchIndex, searchValue.length)}
                </span>
                {item.account_name.substr(searchIndex + searchValue.length)}
              </>
            ) : (
              item.account_name
            )}
          </span>
        ) : (
          <span>
            <b style={{ color: "#1890ff" }}>{item.account_no}</b>
            {" - "}
            {item.account_name}
          </span>
        );

      // Return transformed node
      return {
        key: item.account_no,
        title: title,
        children:
          item.children && item.children.length > 0
            ? transformData(item.children)
            : [],
      };
    });

  const handleData = (e) => {
    console.log(e);
  };

  return (
    <>
      <Search
        style={{ marginBottom: 16, width: "400px" }}
        placeholder="Search by account name or number"
        onChange={onChange}
      />
      <Tree
        showLine={{ showLeafIcon: false }}
        onExpand={onExpand}
        expandedKeys={expandedKeys}
        autoExpandParent={autoExpandParent}
        treeData={transformData(data)}
        onClick={handleData}
        onSelect={(selectedKeys, info) => {
          console.log("selected", selectedKeys, info);
        }}
      />
    </>
  );
};

export default SearchableTree;
